export const GET_PORT_MIRROR = 'GET_PORT_MIRROR';
export const GET_PORT_MIRROR_FAIL = 'GET_PORT_MIRROR_FAIL';
export const GET_PORT_MIRROR_SUCCESS = 'GET_PORT_MIRROR_SUCCESS';
export const GET_PORT_MIRROR_SUCCESS_MSG =
	'SWITCH_DETAILS_RETRIEVED_SUCCESSFULLY';

export const UPDATE_PORT_MIRROR = 'UPDATE_PORT_MIRROR';
export const UPDATE_PORT_MIRROR_FAIL = 'UPDATE_PORT_MIRROR_FAIL';
export const UPDATE_PORT_MIRROR_SUCCESS = 'UPDATE_PORT_MIRROR_SUCCESS';
export const UPDATE_PORT_MIRROR_SUCCESS_MSG =
	'SWITCH_CONFIGURATION_UPDATED_SUCCESSFULLY';
	export const RESET_UPDATE_PORT_MIRROR = 'RESET_UPDATE_PORT_MIRROR';
